define('collections',['controller', 'spinner', 'tooltip-notifier'], function(controller, spin, tooltipNotifier) {

	function onCollectionShowCreateForm() {
		var form = $(this).parent().find('.collection-create-form');
		form.show();
		$(this).hide();
	}

	function onCollectionCreateClick() {
		var dropdown = $(this).closest('.collection-dropdown');
		var title = $(this).parent().find('.collection-create-title').val();
		var is_public = $(this).parent().find('.collection-create-public-state').attr('checked');
		var post_id = dropdown.data('post-id');
		var button = $(this);

		$.ajax({
			url: '/collections/add_json',
			type: 'POST',
			dataType: 'json',
			data: {
				title: title,
				is_public: is_public,
				post_id: post_id
			}
		}).done(function(data) {
			dropdown.empty().html(data.html);
			init(dropdown);
		}).fail(function(e) {
			tooltipNotifier.showError(button, 'Fehler beim Erstellen der Sammlung.', e);
		});
	}

	function onCollectionAddClick() {
		var collection_id = $(this).data('collection-id');
		var post_id = $(this).data('post-id');
		var button = $(this);
		var currentContains = !!button.data('contains');
		var newContains = !currentContains;
		var action = newContains ? 'add_post' : 'remove_post';
		var url = '/collections/' + collection_id + '/' + action + '?post=' + post_id;

		var imgElement = button.children('.collection-contains-img');
		var spinner = new Spinner(button.children('.collection-spinner'), imgElement);

		$.ajax({
			url: url,
			type: 'POST',
			dataType: 'json'
		}).done(function() {
			button.data('contains', newContains);
			imgElement.toggleClass('checked', newContains);
		}).fail(function(e) {
			tooltipNotifier.showError(button, 'Fehler beim Hinzufügen zur Sammlung.', e);
		}).always(function() {
			spinner.done();
		});
	}

	function onCollectionDropdownOpen() {
		var post_id = $(this).data('post-id');
		var dropdown = $('#' + $(this).data('dropdown'));

		$.ajax({
			url: '/collections/' + post_id + '/get_collection_dropdown_html',
			type: 'POST',
			dataType: 'json'
		}).done(function(data) {
			dropdown.empty().html(data.html);
			init(dropdown);
		}).fail(function(xhr) {
			tooltipNotifier.showError(dropdown, 'Fehler', xhr);
		});
	}

	function onCollectionInputKeyup() {
		var search = $(this).val().toLowerCase();

		if(search == '')
			$(this).parent().find('li').show();

		$(this).parent().parent().find('li').each(function() {
			var collection_name = $(this).find('.collection-title').text().toLowerCase();

			if(collection_name.indexOf(search) >= 0)
				$(this).show();
			else
				$(this).hide();
		});
	}

	function init(element) {
		if (typeof(element) === 'undefined') {
			element = $('#page');
		}

		element.find('.collection-add-post').click(onCollectionAddClick);
		element.find('.collection-dropdown-button').on('dropdown-open', onCollectionDropdownOpen);
		element.find('.show-collection-create-form').click(onCollectionShowCreateForm);
		element.find('.collection-create-button').click(onCollectionCreateClick);

		/*
		 * The search event is triggered, when the clear cross for search inputs
		 * in webkit browsers is called
		 */
		$('#page').find('.collection-dropdown-filter').on('search keypress keyup change', onCollectionInputKeyup);
	}

	controller.on(function() {
		init();
	});

	return {
		init: init
	}
});

